import { render, staticRenderFns } from "./SupersessionLineFull.vue?vue&type=template&id=32055a44"
import script from "./SupersessionLineFull.vue?vue&type=script&lang=js"
export * from "./SupersessionLineFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports